import { Component } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';

@Component({
  selector: 'app-inquiry-list',
  templateUrl: './inquiry-list.component.html',
  styleUrls: ['./inquiry-list.component.css']
})
export class InquiryListComponent {
  inquiryData: any = []
  inquiryList = []
  
  constructor(public shared: SharedService, public apiService: ApiServiceService) {
    this.shared.isWhiteMenu = true;
  }
  
  ngOnInit(): void {
    this.getData();
  }

  async getData() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.INQUIRY_LIST, {
    });
  
    if (res && res.data && res.data.rows) {
      this.inquiryData = res.data.rows;
      console.log(this.inquiryData);
    }
  }

  onClickyes() {
    console.log("Click yes");
  }
  
  onClickno() {
    console.log("Click no");
  }

  imageUrl(imageArr : any){
    console.log("imageArr",imageArr)
    if(imageArr && imageArr.length > 0){
      for(let i of imageArr){
        console.log("i",i)
        if(i.category_type == 1){
          console.log("i.images.split(",")[0]",i.images.split(",")[0])
          return (i.images.split(",")[0])
        }
      }
    }
  }
}
